import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import { useMemo } from "react";
import { Helmet } from "react-helmet";
import styles from "./MarketPlaceFaq.module.scss";
import getFaqData, { getFaqStructuredData } from "./get-faq-data";
import getClasses from "utils/getClasses";

interface MarketPlaceFaqProps {
  specialtyLabel: string;
}

const MarketPlaceFaq = ({ specialtyLabel }: MarketPlaceFaqProps) => {
  const { isPhonePortrait } = usePhonePortraitContext();

  const faqData = useMemo(
    () => getFaqData(specialtyLabel, "therapy"),
    [specialtyLabel],
  );

  const faqStructuredData = useMemo(
    () => getFaqStructuredData(specialtyLabel, "therapy"),
    [specialtyLabel],
  );

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqStructuredData)}
        </script>
      </Helmet>

      <div className={styles["wrapper"]}>
        <div
          className={getClasses(
            styles["container"],
            isPhonePortrait && styles["container--mobile"],
          )}
        >
          <h2>FAQ</h2>
          {faqData.map((item) => (
            <div
              key={item.question}
              className={getClasses(
                styles["faq-item"],
                isPhonePortrait && styles["faq-item--mobile"],
              )}
            >
              <h3>{item.question}</h3>
              <div dangerouslySetInnerHTML={{ __html: item.answer }} />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default MarketPlaceFaq;
